import { getPrivateAPIContent } from './index.js';

const convertToRealFieldName = (input) => {
	const defaultField = 'internetPrice';

	const inputValue = input ? input.trim() : null;

	// Note: invoicePrice isn't available in the Web Integration API's Vehicle object,
	// so if a site uses invoice for the config it will actually end up using internetPrice.

	// Also note: 'invoice' is omitted from this array because it doesn't work (yet) and we
	// want to save bytes by not listing prices that don't actually function in this list.
	const prices = ['internet', 'asking', 'sale', 'wholesale'];

	if (prices.includes(inputValue)) {
		return `${inputValue}Price`;
	} else if (inputValue === 'retail') {
		return 'retailValue';
	} else if (inputValue === 'msrp') {
		return inputValue;
	}

	return defaultField;
}

export const getSelectedPriceValue = (vehicle) => {
	const {
		inventoryType,
		finalPrice
	} = vehicle;

	// Get the Accelerate pricing configuration from the Private API
	const priceFieldType = inventoryType === 'used' ? 'usedPriceField' : 'newPriceField';
	const priceFieldInput = getPrivateAPIContent('digital-retailing', priceFieldType);

	// Convert the basic input name like 'internet' to a real field name like 'internetPrice'
	const priceFieldName = convertToRealFieldName(priceFieldInput);

	// Get the selected field from the vehicle object and obtain the price value, with finalPrice as a fallback.
	return vehicle[priceFieldName] && vehicle[priceFieldName] > 0
		? vehicle[priceFieldName]
		: finalPrice;
}
